import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface ValuesSectionProps {
  options: string[];
  selectedValues: string[];
  onValueChange: (value: string) => void;
  renderOption?: (option: string, isSelected: boolean) => React.ReactNode;
  /** Label for empty option (defaults to "None") */
  emptyOptionLabel?: string;
}

export const ValuesSection: React.FC<ValuesSectionProps> = ({
  options,
  selectedValues,
  onValueChange,
  renderOption,
  emptyOptionLabel = 'None',
}) => {
  return (
    <div className="flex flex-col max-h-72 overflow-y-auto">
      {options.length > 0 ? (
        options.map(option => {
          const isSelected = selectedValues.includes(option);
          return (
            <button
              key={option}
              onClick={() => onValueChange(option)}
              className={cn(
                'flex items-center gap-2 px-3 py-2 text-left hover:bg-accent transition-colors',
                isSelected && 'bg-accent/50'
              )}
            >
              <div className="flex items-center justify-center w-4 h-4">
                {isSelected && <Check className="h-4 w-4 text-primary" />}
              </div>
              {renderOption ? (
                renderOption(option, isSelected)
              ) : (
                <span className="text-sm font-medium flex-1">
                  {option || emptyOptionLabel}
                </span>
              )}
            </button>
          );
        })
      ) : (
        <div className="py-4 text-center text-xs text-muted-foreground">
          No values found
        </div>
      )}
    </div>
  );
};
